import { CSSProperties, memo } from 'react';

export const Option = memo(function Option({
  name,
  onClick,
  style
}: {
  name: string;
  onClick?: () => void;
  style?: CSSProperties;
}) {
  return (
    <span
      className={
        'text-xs cursor-pointer py-3 px-4 w-full hover:bg-i_dropdown_hover hover:text-i_dropdown_bg text-i_text'
      }
      style={style}
      onClickCapture={onClick}>
      {name}
    </span>
  );
});
